<template>
  <basic-container>
      <el-row>
          <el-form inline>
              <el-form-item label="姓名">
                <el-input v-model="realName"></el-input>
              </el-form-item>
              <el-form-item label="手机号">
                <el-input v-model="phone"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button @click="searchForm">搜索</el-button>
              </el-form-item>
          </el-form>
      </el-row>
      <el-row>
        <el-col :span="6">
            <el-tabs type="border-card">
                <el-tab-pane label="部门">
                    <el-tree v-loading="treeLoading" :data="departmentTreeList" :props="defaultProps" @node-click="handleNodeClick"></el-tree>

                </el-tab-pane>
                <!--<el-tab-pane label="班组">
                    <el-tree v-loading="treeLoading" :data="groupTreeList" :props="defaultProps_" @node-click="handleNodeClick_"></el-tree>

                </el-tab-pane>-->
            </el-tabs>
            <!-- <div style="text-align:center;padding:1rem 0;">部门</div>
            <div style="border:1px solid #ccc;">
                </div> -->
        </el-col>
        <el-col :span="18">
            <!-- <el-transfer
            @change="transferChangeHandler"
            v-model="dataSelectedUsers"
            :data="dataForUserSelect"
            :titles="['待选项', '已选项']"
            :props="{
                key: 'id',
                label: 'realName'
            }"
            ></el-transfer> -->
            <div style="display:flex;">
                <div style="flex:3;height:500px;overflow:scroll;border:1px solid #ccc;">
                    <div
                        item="for-select"
                        name="item-for-select"
                        style="cursor:pointer;padding:1rem 1rem;"
                        @click="selectUserHandler($event)"
                        v-for="(item,index) in dataForUserSelect"
                        :key="index"
                        :label="item.realName"
                        :value="item.id"
                    >
                        {{item.realName}}
                    </div>
                </div>
                <div style="flex:2;text-align: center;">
                    <el-button type="primary" @click="moveLeftAction" :disabled="moveLeftFlag">左移</el-button>
                    <el-button type="primary" @click="moveRightAction" :disabled="moveRightFlag">右移</el-button>
                </div>
                <div style="flex:3;height:500px;overflow:scroll;border:1px solid #ccc;">
                    <div
                        item="for-select"
                        name="item-for-selected"
                        style="cursor:pointer;padding:1rem 1rem;"
                        @click="selectedUserHandler($event)"
                        v-for="(item,index) in dataSelectedUsers"
                        :key="index"
                        :label="item.realName"
                        :value="item.id"
                    >
                        {{item.realName}}
                    </div>
                </div>
            </div>
        </el-col>
        <!-- <el-col :span="6">
            <div style="text-align:center;padding:1rem 0;">部门</div>
            <div style="border:1px solid #ccc;">
                <el-tree :data="departmentTreeList" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
            </div>
        </el-col> -->
      </el-row>
      <div style="text-align:center;padding:2rem 0;">
          <el-button type="primary" @click.native="submitSelectedUserList">提交</el-button>
          <el-button @click.native="closeUserEditBox">取消</el-button>
      </div>
  </basic-container>
</template>

<script>
    import {
        getDepartmentTreeList,
        treeByProjectDeptId,
        getUserListByDepartmentId,
        getGroupList,
        getPrincipalUserList,
        getMenberUserList,
        } from "@/api/crmedical/group/group";
    export default {
        props:['selectType','projectId','handleAction','remainUserListInside'],
        data(){
            return{
                realName:"",
                phone:"",
                treeLoading:false,
                moveLeftFlag:true,
                moveRightFlag:true,

                tempSelectedItemId:'',
                tempSelectedItemElement:'',

                dataForUserSelect:[],

                dataSelectedUsers:[],

                departmentTreeList:[],

                originUserList:[],

                groupTreeList:[],

                defaultProps: {
                    children: 'children',
                    label: 'title'
                },
                defaultProps_: {
                    label: 'name'
                }
            }
        },
        watch:{

    remainUserListInside: {

      handler(val) {
        console.log(12345678)
        console.log(val)
         if(val){
                this.dataSelectedUsers = this.deepClone(val);
            }else{
                this.dataSelectedUsers = this.deepClone(val);
            }
      },
      deep: true,
    },

        },
        created(){
            console.log(this.remainUserListInside);
            if(this.remainUserListInside){
                this.dataSelectedUsers = this.deepClone(this.remainUserListInside);
            }else{
                this.dataSelectedUsers = this.deepClone(this.remainUserListInside);
            }
            console.log();
            treeByProjectDeptId({projectId:this.projectId}).then((res)=>{
                this.departmentTreeList = res.data;
                console.log(res);
            });
            getGroupList({projectId:this.projectId}).then((res)=>{
                console.log(res);
                this.groupTreeList = res.data;
            });
        },
        methods:{
            searchForm(){

                this.resetAllItem();
                getUserListByDepartmentId({realName:this.realName,phone:this.phone}).then((res)=>{
                    console.log(res);
                    this.originUserList = this.deepClone(res.data);
                    this.dataForUserSelect = this.deepClone(res.data);
                    console.log(this.dataForUserSelect);
                    this.initDataForSelect();
                })
            },
            selectedUserHandler(e){
                // console.log(e.target);
                // console.log(
                // e.target.attributes.label.value,
                // e.target.attributes.value.value
                // )
                this.resetAllItem();
                if(this.tempSelectedItemId){
                    if(this.tempSelectedItemId === e.target.attributes.value.value){
                        e.target.style.backgroundColor="";
                        e.target.style.color="";
                        this.tempSelectedItemId = "";
                        this.tempSelectedItemElement = "";
                        this.moveLeftFlag = true;
                    }else{
                        this.tempSelectedItemId = e.target.attributes.value.value;
                        this.changeRightSelectedItemStyle(e);
                        this.tempSelectedItemElement = e.target;
                        this.moveLeftFlag = false;
                        this.moveLeftFlag = this.filterSelectedUsers();
                    }
                }else{
                    this.tempSelectedItemId = e.target.attributes.value.value;
                    this.changeRightSelectedItemStyle(e);
                    this.tempSelectedItemElement = e.target;
                        this.moveLeftFlag = false;
                        // this.moveLeftFlag = this.filterSelectedUsers();
                }
                // console.log(this.tempSelectedItemId,e.target);
            },
            selectUserHandler(e){
                // console.log(e.target);
                // console.log(
                // e.target.attributes.label.value,
                // e.target.attributes.value.value
                // )
                this.resetAllItem();
                if(this.tempSelectedItemId){
                    if(this.tempSelectedItemId === e.target.attributes.value.value){
                        e.target.style.backgroundColor="";
                        e.target.style.color="";
                        this.tempSelectedItemId = "";
                        this.tempSelectedItemElement = "";
                        this.moveRightFlag = true;
                    }else{
                        this.tempSelectedItemId = e.target.attributes.value.value;
                        this.changeLeftSelectedItemStyle(e);
                        this.tempSelectedItemElement = e.target;
                        this.moveRightFlag = false;
                    }
                }else{
                    this.tempSelectedItemId = e.target.attributes.value.value;
                    this.changeLeftSelectedItemStyle(e);
                    this.tempSelectedItemElement = e.target;
                        this.moveRightFlag = false;
                }
                console.log(this.tempSelectedItemId,e.target);
            },
            resetAllItem(){
                        this.tempSelectedItemId = "";
                        this.tempSelectedItemElement = "";
                        this.moveRightFlag = true;
                        this.moveLeftFlag = true;
                document.querySelectorAll('div[item="for-select"]').forEach((ele)=>{
                    ele.style.backgroundColor="";
                    ele.style.color="";
                });
            },
            changeLeftSelectedItemStyle(e){
                document.querySelectorAll('div[name="item-for-select"]').forEach((ele)=>{
                    ele.style.backgroundColor="";
                    ele.style.color="";
                });
                e.target.style.backgroundColor="#F5F7FA";
                e.target.style.color="#409eff";
            },
            changeRightSelectedItemStyle(e){
                document.querySelectorAll('div[name="item-for-selected"]').forEach((ele)=>{
                    ele.style.backgroundColor="";
                    ele.style.color="";
                });
                e.target.style.backgroundColor="#F5F7FA";
                e.target.style.color="#409eff";
            },
            filterSelectedUsers(){
                let filterFlag = true;
                this.originUserList.forEach((element,index)=>{
                    if(this.tempSelectedItemId === element.id){
                        filterFlag = false;
                    }
                });
                return filterFlag;
            },
            moveRightAction(){
                let self = this;
                this.dataForUserSelect.forEach((ele,index)=>{
                    console.log(self.tempSelectedItemElement.attributes.value.value,ele.id);
                    if(ele.id === self.tempSelectedItemElement.attributes.value.value){
                        this.dataForUserSelect.splice(index,1);
                    }
                });
                console.log(this.dataForUserSelect);
                this.dataSelectedUsers.push({id:this.tempSelectedItemElement.attributes.value.value,realName:this.tempSelectedItemElement.attributes.label.value});
                this.resetAllItem();
            },
            moveLeftAction(){
                let self = this;
                this.dataSelectedUsers.forEach((ele,index)=>{
                    console.log(self.tempSelectedItemElement.attributes.value.value,ele.id);
                    if(ele.id === self.tempSelectedItemElement.attributes.value.value){
                        this.dataSelectedUsers.splice(index,1);
                    }
                });
                console.log(this.dataForUserSelect);
                this.dataForUserSelect.push({id:this.tempSelectedItemElement.attributes.value.value,realName:this.tempSelectedItemElement.attributes.label.value});

                console.log(this.dataForUserSelect);
                this.resetAllItem();
            },
            // transferChangeHandler(a,b,c){
            //     console.log(a,b,c)
            //     console.log(this.dataSelectedUsers)
            // },
            // transferRightChangeHandler(){
            //     console.log(this.dataSelectedUsers)
            // },
            // transferLeftChangeHandler(){
            //     console.log(this.dataSelectedUsers)
            // },
            handleNodeClick(data){
                this.treeLoading = true;
                this.resetAllItem();
                let deptId= data.id;
                getUserListByDepartmentId({deptId}).then((res)=>{
                    console.log(res);
                    // this.dataForUserSelect = Object.assign({}, this.dataForUserSelect, res.data)

                    this.originUserList = this.deepClone(res.data);
                    this.dataForUserSelect = this.deepClone(res.data);
                    console.log(this.dataForUserSelect);
                    this.initDataForSelect();
                    this.treeLoading = false;
                });
                console.log(data);

            },


            handleNodeClick_(data){
                this.treeLoading = true;
                this.resetAllItem();
                let groupId= data.id;
                if(this.selectType==1){

                    getMenberUserList({groupId}).then((res)=>{
                        console.log(res);
                        // this.dataForUserSelect = Object.assign({}, this.dataForUserSelect, res.data)

                        this.originUserList = this.deepClone(res.data);
                        this.dataForUserSelect = this.deepClone(res.data);
                        console.log(this.dataForUserSelect);
                        this.initDataForSelect();
                        this.treeLoading = false;
                    });
                    console.log(data);
                }else{
                    getPrincipalUserList({groupId}).then((res)=>{
                        console.log(res);
                        // this.dataForUserSelect = Object.assign({}, this.dataForUserSelect, res.data)

                        this.originUserList = this.deepClone(res.data);
                        this.dataForUserSelect = this.deepClone(res.data);
                        console.log(this.dataForUserSelect);
                        this.initDataForSelect();
                        this.treeLoading = false;
                    });
                    console.log(data);
                }

            },


            initDataForSelect(){
                console.log('initDataForSelect');
                let arrListSelected = this.deepClone(this.dataSelectedUsers);
                let arrListForSelect = this.deepClone(this.dataForUserSelect);
                if(arrListSelected.length>0){
                   arrListSelected.forEach((ele,i)=>{
                         arrListForSelect.forEach((element,index)=>{
                            if(element.id === ele.id){

                                console.log(element.id,ele.id,i);
                                arrListForSelect.splice(index,1);
                                console.log(arrListForSelect);
                            }
                        });
                    });
                }

                                this.dataForUserSelect = arrListForSelect;

            },
            closeUserEditBox(){
                this.$emit('closeAction')
            },
            submitSelectedUserList(){
                let idList = [];
                let idListString = '';
                let nameList = [];
                let nameListString = '';
                this.dataSelectedUsers.forEach((e,i)=>{
                    idList.push(e.id);
                    nameList.push(e.realName);
                });
                if(idList.length>0){
                    idListString = idList.join(',');
                    nameListString = nameList.join(',');
                    if(this.handleAction==1){

                        this.$emit('submitAction',{selectType:this.selectType,idListString:idListString,nameListString:nameListString,dataSelectedUsers:this.dataSelectedUsers});
                    }else{
                        this.$emit('editAction',{selectType:this.selectType,idListString:idListString,nameListString:nameListString,dataSelectedUsers:this.dataSelectedUsers});

                    }
                }else{
                    // idListString = idList.join(',');
                    // nameListString = nameList.join(',');
                    if(this.handleAction==1){

                        this.$emit('submitAction',{selectType:this.selectType,idListString:idListString,nameListString:nameListString,dataSelectedUsers:this.dataSelectedUsers});
                    }else{
                        this.$emit('editAction',{selectType:this.selectType,idListString:idListString,nameListString:nameListString,dataSelectedUsers:this.dataSelectedUsers});

                    }
                }
            },



        }
    }
</script>

<style>

</style>
